import React from "react";
import { SEO, MainLayout, QuotLocation } from "../../../../components";

const QuotLocationPage = () => {
  return (
    <>
      <SEO title="location" />
      <MainLayout>
        <QuotLocation />
      </MainLayout>
    </>
  );
};

export default QuotLocationPage;
